// iConnect — Service area map (flexi-iconnect-service-area-map.php)
// Requires GSAP and ScrollTrigger to be loaded before this file.
//
// Intro: land fades in, routes draw out from Mandurah and suburbs pop in,
// rippling outward by distance. Then the hub pulses and keeps "dispatching"
// a dot along a route to a random suburb. Hovering a pill dispatches to it.

gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll('.iconnect-sam').forEach((section) => {
    const svg     = section.querySelector('.iconnect-sam__svg');
    const hub     = svg.querySelector('.iconnect-sam__loc--hub');
    const locs    = [...svg.querySelectorAll('.iconnect-sam__loc:not(.iconnect-sam__loc--hub)')];
    const pulse   = svg.querySelector('.iconnect-sam__pulse');
    const hubX    = +hub.dataset.x;
    const hubY    = +hub.dataset.y;
    const route   = (loc) => svg.querySelector(`.iconnect-sam__route[data-slug="${loc.dataset.slug}"]`);
    const dist    = (loc) => Math.hypot(loc.dataset.x - hubX, loc.dataset.y - hubY);
    const byDist  = [...locs].sort((a, b) => dist(a) - dist(b));
    const maxDist = dist(byDist[byDist.length - 1]);

    let sendTo = null;

    // Pill <-> map highlight (works with or without motion).
    section.querySelectorAll('.iconnect-sam__pill').forEach((pill) => {
        const loc = svg.querySelector(`.iconnect-sam__loc[data-slug="${pill.dataset.slug}"]`);
        if (!loc) return;

        const toggle = (on) => {
            loc.classList.toggle('is-active', on);
            route(loc)?.classList.toggle('is-active', on);
        };

        pill.addEventListener('mouseenter', () => { toggle(true); sendTo?.(loc); });
        pill.addEventListener('mouseleave', () => toggle(false));
        loc.addEventListener('mouseenter', () => pill.classList.add('is-active'));
        loc.addEventListener('mouseleave', () => pill.classList.remove('is-active'));
    });

    gsap.matchMedia().add('(prefers-reduced-motion: no-preference)', () => {
        let trip;
        let next;
        let last;

        // Travel a pulse from the hub to a suburb, flash it, then queue the next trip.
        const send = (loc) => {
            trip?.kill();
            next?.kill();
            last = loc;

            const line = route(loc);
            const dot  = loc.querySelector('.iconnect-sam__dot');

            trip = gsap.timeline({
                onComplete: () => { next = gsap.delayedCall(1.4, () => send(randomLoc())); },
            })
                .call(() => line.classList.add('is-live'))
                .set(pulse, { attr: { cx: hubX, cy: hubY }, opacity: 1 })
                .fromTo(hub.querySelector('.iconnect-sam__dot'), { scale: 1 }, { scale: 1.35, duration: 0.15, yoyo: true, repeat: 1, transformOrigin: '50% 50%' }, 0)
                .to(pulse, { attr: { cx: loc.dataset.x, cy: loc.dataset.y }, duration: 0.4 + dist(loc) / 320, ease: 'power2.inOut' }, 0)
                .set(pulse, { opacity: 0 })
                .fromTo(dot, { scale: 1 }, { scale: 2.2, duration: 0.2, yoyo: true, repeat: 1, ease: 'power2.out', transformOrigin: '50% 50%' }, '<')
                .call(() => line.classList.remove('is-live'));
        };

        const randomLoc = () => {
            const pool = locs.filter((loc) => loc !== last);
            return pool[Math.floor(Math.random() * pool.length)];
        };

        // Intro delay grows with the suburb's distance from the hub, so the map fills outward.
        const delayFor = (i, el) => {
            const loc = svg.querySelector(`.iconnect-sam__loc[data-slug="${el.closest('[data-slug]').dataset.slug}"]`);
            return 0.4 + (dist(loc) / maxDist) * 1.2;
        };

        const intro = gsap.timeline({
            scrollTrigger: { trigger: section, start: 'top 75%', once: true },
            onComplete: () => {
                sendTo = send;
                send(byDist[0]);
            },
        });

        intro
            .from(svg.querySelector('.iconnect-sam__land'), { opacity: 0, x: 40, duration: 1, ease: 'power2.out' }, 0)
            .from(svg.querySelectorAll('.iconnect-sam__estuary'), { opacity: 0, duration: 1 }, 0.3)
            .from(hub.querySelectorAll('.iconnect-sam__dot, .iconnect-sam__ring'), { scale: 0, duration: 0.6, ease: 'back.out(3)', transformOrigin: '50% 50%' }, 0.3)
            .from(hub.querySelector('.iconnect-sam__label'), { opacity: 0, x: 10, duration: 0.5 }, 0.5)
            .fromTo(svg.querySelectorAll('.iconnect-sam__route'),
                { strokeDasharray: 1, strokeDashoffset: 1 },
                { strokeDashoffset: 0, duration: 0.6, ease: 'power1.out', delay: delayFor, clearProps: 'strokeDasharray,strokeDashoffset' }, 0)
            .from(locs.map((loc) => loc.querySelector('.iconnect-sam__dot')),
                { scale: 0, duration: 0.4, ease: 'back.out(3)', transformOrigin: '50% 50%', delay: (i, el) => delayFor(i, el) + 0.45 }, 0)
            .from(locs.map((loc) => loc.querySelector('.iconnect-sam__label')),
                { opacity: 0, duration: 0.4, delay: (i, el) => delayFor(i, el) + 0.5 }, 0);

        // Radar ripples + breathing ring on the hub, always running.
        gsap.fromTo(hub.querySelectorAll('.iconnect-sam__ripple'),
            { attr: { r: 13 }, opacity: 0.7 },
            { attr: { r: 46 }, opacity: 0, duration: 2.6, ease: 'power1.out', repeat: -1, stagger: 1.3, delay: 1 });

        gsap.to(hub.querySelector('.iconnect-sam__ring'), { attr: { r: 16 }, duration: 1.3, ease: 'sine.inOut', yoyo: true, repeat: -1 });

        return () => {
            sendTo = null;
        };
    });
});
